import { useRef } from 'react';

// Imports custom
import {
    CustomTableCheck,
    LinearLoading
} from 'common'

export const MoraPendienteTable = ({ useFetchInit }) => {

    const processingSelection = useRef(false);

    const {
        Forms,
        FetchData,
        globalStates
    } = useFetchInit

    const { formOpeningMode } = globalStates

    // ------------------------------------------------ Formularios
    const { FormRequestGlobal } = Forms
    const { formState, onInputChange } = FormRequestGlobal

    // ------------------------------------------------ FetchData
    const { fetchMoraPendienteByCredit } = FetchData
    const { dataMoraPendiente, loadingFetchMoraPendiente } = fetchMoraPendienteByCredit

    const isReadOnly = (formOpeningMode === 'READONLY')
    const dataToShow = isReadOnly
        ? formState.exoneraciones
        : dataMoraPendiente

    const columnConfig = [
        {
            headerName: '',
            width: 60,
            checkboxSelection: !isReadOnly,
            headerCheckboxSelection: !isReadOnly,
            pinned: 'left',
            suppressMenu: true,
            sortable: false,
            filter: false,
            resizable: false
        },
        { field: 'no_cuota', headerName: 'No. CUOTA', minWidth: 150, filter: true },
        { field: 'fecha_pago', headerName: 'F. PAGO', minWidth: 150, filter: true },
        { field: 'fecha_cierre', headerName: 'F. CIERRE', minWidth: 150, filter: true },
        { field: 'dias_atraso', headerName: 'DIAS ATRASO', minWidth: 150, filter: true },
        {
            field: 'mora_cuota', headerName: 'MORA CUOTA', minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        {
            field: 'mora_pendiente', headerName: 'MORA PENDIENTE', minWidth: 170, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        {
            headerName: 'ESTADO', minWidth: 170,
            cellRenderer: (params) => (params.data.flag_mora_calculada ? 'CERRADA' : 'VIGENTE EN ATRASO')
        },
    ]

    // A diferencia de la gestion RDP (donde los pagos se revierten en orden LIFO y por eso hay
    // que seleccionar en bloque desde la fila hasta el final), aqui la seleccion es libre: el
    // gestor puede elegir cualquier subconjunto de cuotas con mora pendiente.
    const handleRowSelected = (event) => {

        // Evita que el mismo evento se dispare en cascada
        if (processingSelection.current) return;

        processingSelection.current = true;

        const { api } = event;

        onInputChange({
            target: {
                name: 'rowSelectedExoneracion',
                value: api.getSelectedRows()
            }
        });

        processingSelection.current = false;
    };

    return (
        <div className='content'>
            {(loadingFetchMoraPendiente) && (<LinearLoading />)}
            <CustomTableCheck
                rowConfig={dataToShow}
                columnConfig={columnConfig}
                onRowSelected={handleRowSelected}
            />
        </div>
    )
}
